import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MOCK_URL_HEADER_MENU } from '@ibe.config';
import { INDRAStorageService } from './storage.indra.service';
import { INDRAApiService } from './api.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./api.indra.service";
import * as i3 from "./storage.indra.service";
var INDRAHeaderService = /** @class */ (function () {
    function INDRAHeaderService(http, apiIndra, storage) {
        this.http = http;
        this.apiIndra = apiIndra;
        this.storage = storage;
        this.language = new BehaviorSubject(sessionStorage.getItem('language'));
    }
    INDRAHeaderService.prototype.INDRA_getHeaderMenu = function () {
        return this.http.get(MOCK_URL_HEADER_MENU);
    };
    /*
    public getToken(): Observable<string> {
        const tokenURL = this.ibeAdminConfigService.getConfigurationValue('externalURLs.token');
        if (tokenURL != 'externalURLs.token') {
            const data = {
                username: 'devflytapapi',
                password: 'password',
                grant_type: 'password'
            };
            return this.http.post<string>(`${tokenURL}`, data);
        } else return new BehaviorSubject(undefined);
    }
    */
    INDRAHeaderService.prototype.setLanguage = function (lang) {
        this.language.next(lang);
    };
    INDRAHeaderService.prototype.getLanguage = function () {
        return this.language.asObservable();
    };
    INDRAHeaderService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAHeaderService_Factory() { return new INDRAHeaderService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAApiService), i0.inject(i3.INDRAStorageService)); }, token: INDRAHeaderService, providedIn: "root" });
    return INDRAHeaderService;
}());
export { INDRAHeaderService };
